import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import Form, {
  RegisterCertificationForm,
} from 'front-office/components/register-certification/form';
import { RegisterCertificationCrumbs } from 'front-office/constants/register-certification-crumbs';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { toast } from 'react-toastify';
import { useUserProfile } from 'shell/hooks/use-user-profile';

const RegisterCertificationNew = (): React.ReactElement => {
  const { userProfile } = useUserProfile();
  const insertRegisterCertification = useHttpClient(
    `${__CERTIFICATION_API_URL__}/certificazione/tipi-registro`,
    {
      options: {
        errorCatching: true,
        method: 'POST',
        loading: true,
        data: {},
      },
    }
  );

  const navigate = useNavigate();

  const onOk = (form: RegisterCertificationForm | undefined) => {
    (
      insertRegisterCertification({
        data: {
          sigla: form?.initials,
          descrizione: form?.description,
          key: {
            codice: form?.type,
            codiceEnte: userProfile.datiLogin?.profile?.servizio?.key?.codiceEnte || '',
          },
        },
      }) as ResponsePromise<void, void>
    ).then(() => {
      toast.success('Operazione eseguita con successo');
      navigate('/sportello/ricerca-registro');
    });
  };

  return (
    <Fragment>
      <Breadcrumbs items={[...RegisterCertificationCrumbs, { name: 'Nuovo Registro' }]} />
      <Form
        onOk={onOk}
        onCancel={() => {
          navigate('/sportello/ricerca-registro');
        }}
        title="Nuovo Registro"
      />
    </Fragment>
  );
};

RegisterCertificationNew.displayName = 'Register certification new page component';

export default RegisterCertificationNew;
